import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import colors from '@/plugins/colors'

Vue.use(Vuetify);

export default new Vuetify({
    theme: {
        themes: {
            light: {
                primary: colors.primary,
                beige: colors.beige
            },
        },
    },
});
